"use client";

import { LoadingWrapper } from "@packages/ui";
import { useRouter } from "next/navigation";
import { Fragment, useEffect } from "react";

interface BibleChapterRedirectProps {
  translation: string;
  book: string;
}

export const BibleChapterRedirect = ({
  translation,
  book,
}: BibleChapterRedirectProps) => {
  const router = useRouter();

  useEffect(() => {
    router.replace(`/bible/${translation}/${book}/1`);
  }, [translation, book, router]);

  return (
    <LoadingWrapper isLoading={true}>
      <Fragment />
    </LoadingWrapper>
  );
};
